import { useTranslation } from 'react-i18next'
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/radio-group'
import { Label } from '@/components/shadcn/label'
import type { ChecklistAnswerType } from '@/api/model';
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types';

const OPTIONS: { value: ChecklistAnswerType; labelKey: string }[] = [
  { value: 'SingleChoice', labelKey: 'subtypes.checklistAnswer.checklistAnswerTypeSingleChoice' },
  { value: 'MultipleChoice', labelKey: 'subtypes.checklistAnswer.checklistAnswerTypeMultipleChoice' },
  { value: 'MultipleChoiceWithDecline', labelKey: 'subtypes.checklistAnswer.checklistAnswerTypeMultipleChoiceWithDecline' },
]

export function ChecklistAnswerTypeEditor(props: PropertyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  return (
    <RadioGroup value={(props.value as string) ?? ''} onValueChange={v => props.onChanged(v)}>
      {OPTIONS.map(o => (
        <Label key={o.value} className="flex items-center gap-2 font-normal">
          <RadioGroupItem value={o.value} />
          {t(o.labelKey)}
        </Label>
      ))}
    </RadioGroup>
  )
}
